import { useState } from 'react';
import { discussions } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function CommunitySection() {
  const [draft, setDraft] = useState('');
  const [notice, setNotice] = useState('');

  const handlePost = () => {
    if (!draft.trim()) {
      setNotice('先说点什么再发出去，哪怕是补充一个时间点。');
      return;
    }
    setNotice('演示站点：讨论区暂未接入，内容不会真正发布，感谢你的补充。');
  };

  return (
    <section id="community" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          index="06"
          eyebrow="Community"
          title="社区讨论区"
          desc="时间线靠大家一起补：有人补线索，有人纠错，有人只想知道从哪开始看。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.5fr_1fr] lg:gap-12">
          <div className="border-t border-background-200">
            {discussions.map((item) => (
              <article key={item.id} className="border-b border-background-200 py-6 md:py-7">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-foreground-950 font-heading text-sm text-background-50">
                    {item.avatar}
                  </span>
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-sm text-foreground-950">{item.author}</span>
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">
                        {item.badge}
                      </span>
                      {item.hot ? (
                        <span className="flex items-center gap-1 font-label text-[11px] text-primary-600">
                          <i className="ri-fire-line text-xs" />
                          热议
                        </span>
                      ) : null}
                    </div>
                    <span className="font-label text-[11px] text-foreground-400">{item.time}</span>
                  </div>
                </div>

                <h3 className="mt-4 font-heading text-base leading-snug text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.body}</p>

                <div className="mt-4 flex items-center gap-6 font-label text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-sm" />
                    {item.replies} 条回复
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-thumb-up-line text-sm" />
                    {item.likes}
                  </span>
                </div>
              </article>
            ))}
          </div>

          <aside className="h-fit rounded-lg border border-background-200 bg-background-100 p-6 md:p-7">
            <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
              <i className="ri-edit-2-line text-xl text-primary-600" />
              补充一条线索
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              写清时间点和你看到的原始内容，编辑会把它对到对应节点上。
            </p>
            <textarea
              value={draft}
              onChange={(event) => setDraft(event.target.value.slice(0, 500))}
              rows={5}
              maxLength={500}
              placeholder="例如：某条动态的实际发布时间比归档版本早 40 分钟……"
              className="mt-4 w-full resize-none rounded-md border border-background-300 bg-background-50 p-3 text-sm text-foreground-800 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none"
            />
            <div className="mt-2 flex items-center justify-between font-label text-xs text-foreground-400">
              <span>最多 500 字</span>
              <span>{draft.length}/500</span>
            </div>
            <button
              type="button"
              onClick={handlePost}
              className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 text-sm text-background-50 transition-opacity hover:opacity-90"
            >
              <i className="ri-send-plane-line text-base" />
              发布补充
            </button>
            {notice ? (
              <p className="mt-3 rounded-md bg-background-200 px-3 py-2 text-xs text-foreground-600">
                {notice}
              </p>
            ) : null}
          </aside>
        </div>
      </div>
    </section>
  );
}